import React, { useEffect } from "react";
import MainLayout from "../../../layout";
import { TextView } from "../../../components/view-form-components/text-view";
import { ImageView } from "../../../components/view-form-components/image.view";
import ResetPasswordModal from "../../../components/modal/reset-password-modal";
import { useState } from "react";
import CommentsComponent from "../../../components/comments/comments";
import FileCommentComponent from "../../../components/comments/file-comment";
import axios from "axios";
import { url } from "../../../config";
import { useNavigate, useParams } from "react-router-dom";
import DeleteModal from "../../../components/modal/delete-modal";
import SwitchView from "../../../components/view-form-components/switch-view";
import backArrow from "../../../assets/icons/back-arrow.svg";

const ReadUsers = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [openResetPassowrd, setOpenResetPassowrd] = useState(false);

  const fetchData = () => {
    setLoading(true);
    axios
      .post(`${url}/ffadmin/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteFnc = (id) => {
    axios
      .post(`${url}/ffadmin/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        navigate("/admin/users/list");
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  return (
    <MainLayout>
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
        }}
        btnFnc={() => deleteFnc(params?.id)}
      />
      <ResetPasswordModal
        id={params?.id}
        isOpen={openResetPassowrd}
        onClose={() => setOpenResetPassowrd(false)}
      />
      <section className="h-full overflow-auto px-3">
        <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
          <div className="flex items-center gap-2">
            <button onClick={() => navigate(-1)} type="button">
              <img src={backArrow} alt="<" width={10} height={10} />
            </button>
            <h2 className="text-xl font-semibold capitalize">
              Admin Users - view
            </h2>
          </div>

          <div className="flex gap-3 items-center">
            <button
              onClick={() => setOpenResetPassowrd(true)}
              className="px-4 py-1 bg-white border-[2px] border-primary text-primary rounded"
            >
              Reset password
            </button>
            <button
              onClick={() => {
                setdeleteModalShow(true);
              }}
              className="px-4 py-1 bg-errorColor border-[2px] border-errorColor text-white rounded"
            >
              Delete
            </button>
          </div>
        </div>
        <section className="w-full max-w-[40rem]"></section>
        <ImageView label={"profile picture"} value={data?.profile_picture} />
        <TextView label={"Name"} value={data?.name} />
        <TextView label={"Email"} value={data?.email} />
        <TextView label={"description"} value={data?.description} />
        <SwitchView label={"Enabled"} value={data?.enabled ?? false} />

        {/* <CommentsComponent /> */}
        {/* <FileCommentComponent /> */}
      </section>
    </MainLayout>
  );
};

export default ReadUsers;
